// v2
import Application from '~/services/_core/application';
import ApplicationStatus from '~/services/_core/application-status';
import AuthService from '~/services/_core/auth';
import Notification from '~/services/_core/notification';
import User from '~/services/_core/user';
import SupportSettings from '~/services/_core/support-settings';
import FeatureSettings from '~/services/_core/feature-settings';

// v3
import ApplicationV3 from '~/services/_core/v3/application';
import OAuthV3 from '~/services/_core/v3/oauth';
import UserV3 from '~/services/_core/v3/user';
import AuthV3 from '~/services/_core/v3/auth';

export default [
  Application,
  ApplicationStatus,
  AuthService,
  Notification,
  User,
  SupportSettings,
  FeatureSettings,
  ApplicationV3,
  OAuthV3,
  UserV3,
  AuthV3
];
